/** First two dimensions, with a unit that may follow a third (depth) value. */
export function sizeLabelDimensionsCm(text: string): { width: number; height: number } | null {
  const match = text.replace(/×/g, 'x').match(/(\d+(?:[.,]\d+)?)\s*(in|inch|inches|")?\s*(?:x|X|_)\s*(\d+(?:[.,]\d+)?)(?:\s*(?:x|X|_)\s*\d+(?:[.,]\d+)?)?\s*(mm|cm|in|inch|inches|")?/i);
  if (!match) return null;
  const unit = (match[4] || match[2] || 'cm').toLowerCase();
  const factor = unit === 'mm' ? 0.1 : ['in', 'inch', 'inches', '"'].includes(unit) ? 2.54 : 1;
  const width = Number(match[1].replace(',', '.')) * factor;
  const height = Number(match[3].replace(',', '.')) * factor;
  return width > 0 && height > 0 ? { width, height } : null;
}
